import { AccessorialCode, DomainReference } from '@rygen/rygen-ui/model';

import { ShipmentStopType } from '../shipment/ShipmentStopType';

import { QuickQuoteLineItem } from './QuickQuoteLineItem';
import { QuickQuoteShippingPoint } from './QuickQuoteShippingPoint';

export class QuickQuoteRequest {
  id?: number;
  owner?: DomainReference;
  origin: QuickQuoteShippingPoint = new QuickQuoteShippingPoint({
    stopType: ShipmentStopType.PICKUP,
  });
  destination: QuickQuoteShippingPoint = new QuickQuoteShippingPoint({
    stopType: ShipmentStopType.DROP_OFF,
  });
  lineItems: QuickQuoteLineItem[] = [];
  requestedAccessorials: AccessorialCode[] = [];
  serviceType?: string = 'ALL_AVAILABLE';

  constructor(opts?: Partial<QuickQuoteRequest>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.owner != null) {
      this.owner = new DomainReference(opts.owner);
    }
    if (opts?.origin != null) {
      this.origin = new QuickQuoteShippingPoint({
        ...opts.origin,
        stopType: ShipmentStopType.PICKUP,
      });
    }
    if (opts?.destination != null) {
      this.destination = new QuickQuoteShippingPoint({
        ...opts.destination,
        stopType: ShipmentStopType.DROP_OFF,
      });
    }
    if (opts?.lineItems != null) {
      this.lineItems = opts.lineItems.map((val) => new QuickQuoteLineItem(val));
    }
    if (opts?.requestedAccessorials != null) {
      this.requestedAccessorials = opts.requestedAccessorials.map(
        (val) => new AccessorialCode(val),
      );
    }
    if (opts?.serviceType != null) {
      this.serviceType = opts.serviceType;
    }
  }

  get isHazardous(): boolean {
    return this.lineItems.some((li) => li.isHazmat);
  }

  get stops(): [
    origin: QuickQuoteShippingPoint,
    destination: QuickQuoteShippingPoint,
  ] {
    return [this.origin, this.destination];
  }

  set stops([origin, destination]: [
    origin: QuickQuoteShippingPoint,
    destination: QuickQuoteShippingPoint,
  ]) {
    this.origin = origin;
    this.destination = destination;
  }
}
